<template>
    <div>

        <vue-headful title="Alerts :: MeritEHS"/>

        <h4 class="py-3 mb-3">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-bell"></i> Alerts</li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="alertsTable" url="/alerts/list" :columns="columns" :options="options">

                    <router-link slot="subject" slot-scope="props" :to="`/alerts/view/${props.row.id}`" title="View Alert">
                        {{ props.row.subject }}
                    </router-link>

                    <template slot="LastName" slot-scope="props">
                        <template v-if="props.row.creator_id">{{ props.row.FirstName }} {{ props.row.LastName }}</template>
                        <template v-else>System</template>
                    </template>

                    <template slot="created_at" slot-scope="props">
                        {{ props.row.created_at_formatted }}
                    </template>

                    <template slot="read_at" slot-scope="props">
                        {{ props.row.read_at_formatted }}
                    </template>

                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                columns: ['subject', 'LastName', 'created_at', 'read_at'],
                options: {
                    headings: {
                        subject: 'Subject',
                        LastName: 'Created By',
                        created_at: 'Timestamp',
                        read_at: 'Read',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'created_at',
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        methods: {

        },
    }
</script>
